<template>
  <nav class="custom-breadcrumb">
    <ol>
      <li v-for="item in items" :key="item.to" class="custom-breadcrumb__item" :class="item.isCurrent && 'active'">
        <span v-if="item.isCurrent">{{ item.text }}</span>
        <a :href="item.to" v-else>{{ item.text }}</a>
      </li>
    </ol>
  </nav>
</template>

<script>
export default {
  props: {
    items: []
  }
}
</script>

<style scoped lang="scss">
.custom-breadcrumb {
  ol {
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 1rem;
    padding: 0;
  }

  &__item {
    &:not(:first-child) {
      margin-left: 7px;

      &::before {
        float: left;
        padding-right: 5px;
        content: "/";
      }
    }
    &.active {
      color: #333333;
      cursor: initial;
      pointer-events: none;
    }
  }
}
</style>
